/**
 * Regular Expression to test valid WebSocket (wss and ws) hosts
 * @public
 */
export const isWebSocketExpression = new RegExp(/wss?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)\b\/*$/, 'i');
